<template>
    <div :class="{ 'prevent-click': !hasPerm('parts.update') }">
        <v-card color="grey lighten-4" class="mb-3">
            <v-card-title class="pl-2 py-3 grey lighten-1" :style="$bp.smAndUp ? 'height:60px' : ''">
                <div>
                    <div class="headline">Receiving</div>
                </div>
            </v-card-title>
        </v-card>
        <v-form ref="part">
            <v-card color="grey lighten-4" class="mb-3">
                <v-card-title class="pl-2 py-3 grey lighten-1" :style="$bp.smAndUp ? 'height:60px' : ''">
                    <div>
                        <div class="headline">Setting</div>
                    </div>
                </v-card-title>
                <v-card-actions class="pb-0">
                    <app-section-loader :status="setting_form_loader"></app-section-loader>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 sm8>
                                <v-textarea
                                    v-model="edit_part.setting_instructions"
                                    :label="$t('lang.instructions')"
                                    auto-grow
                                    rows="1"
                                    hide-details
                                    :rules="ifValid('part.setting_instructions')"
                                    class="mb-2 max-height-text-area"
                                ></v-textarea>
                            </v-flex>
                            <v-flex :class="hasPerm('parts.update') ? 'xs8 sm2' : 'xs12 sm4'">
                                <v-text-field
                                    v-model="edit_part.setting_minutes_to_complete"
                                    :label="$t('lang.minutes_to_complete')"
                                    :counter="showCounter(edit_part.setting_minutes_to_complete, 'part.setting_minutes_to_complete')"
                                    :rules="ifValid('part.setting_minutes_to_complete')"
                                    type="number"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs4 sm2 v-if="hasPerm('parts.update')">
                                <v-btn color="success" @mouseup.left="modifyPart()" class="mt-2">
                                    {{ $t("lang.save") }}
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-form>
        <v-card v-for="(station_group, key, group_index) in grouped_stations" :key="group_index" color="grey lighten-4" class="mb-3">
            <v-radio-group column hide-details style="display: block" v-model="prime_stations[group_index]" class="pt-0">
                <div v-for="(station, station_index) in station_group" :key="station_index">
                    <v-hover>
                        <v-card-title
                            slot-scope="{ hover }"
                            style="padding-bottom: 10px; padding-top: 12px"
                            :style="$bp.smAndUp ? 'height:60px' : ''"
                            :class="[$bp.xsOnly ? 'px-2' : '', initial_stations[group_index] == station.part_station_id ? 'grey lighten-1' : 'grey lighten-2']"
                        >
                            <v-layout row wrap :style="$bp.smAndUp ? 'height:60px' : ''">
                                <!-- <v-flex xs2 sm1 :style="$bp.smAndUp ? 'max-width: 50px;' : ''" pr-0 v-if="station_group.length > 1">
                                    <v-radio
                                        class="mr-1"
                                        :value="station.part_station_id"
                                    ></v-radio>
                                </v-flex>
                                <v-flex :class="station_group.length > 1 ? 'pl-0 xs10 sm6' : 'xs10 sm7'">
                                    <div class="headline cursor-pointer">{{ station.label }}</div>
                                </v-flex> -->
                                <v-flex xs10 sm7 d-inline-flex pr-0 pl-1 my-auto>
                                    <v-radio
                                        v-if="station_group.length > 1 && hasPerm('parts.update')"
                                        class="mr-1"
                                        style="max-width: 30px"
                                        :value="station.part_station_id"
                                    ></v-radio>
                                    <div
                                        @mouseup.left="openPartStation(station, group_index)"
                                        class="headline cursor-pointer clickable"
                                        :class="{ 'text-truncate': $bp.smAndUp }"
                                    >
                                        {{ station.label }}
                                    </div>
                                </v-flex>
                                <v-flex xs6 sm1 my-auto text-center clickable px-1 @mouseup.left="openPartStation(station, group_index)">
                                    {{ station.pattern_number }}
                                </v-flex>
                                <v-flex xs6 sm1 my-auto text-center clickable px-1 @mouseup.left="openPartStation(station, group_index)">
                                    {{ station.minutes_to_complete ? `${station.minutes_to_complete} min` : "" }}
                                </v-flex>
                                <v-flex xs6 sm2 px-0 :key="station_loader_key">
                                    <v-btn
                                        v-if="
                                            hasPerm('parts.update') &&
                                            station_group.length > 1 &&
                                            prime_stations[group_index] == station.part_station_id &&
                                            prime_stations[group_index] != initial_stations[group_index]
                                        "
                                        class="my-0 float-right"
                                        color="primary"
                                        @mouseup.left="update_loader[group_index] ? null : modifyPartStationPrime(prime_stations[group_index], group_index)"
                                    >
                                        <v-icon v-if="update_loader[group_index]" color="white" class="ma-auto">{{ "fas fa-circle-notch fa-spin" }}</v-icon>
                                        <span v-else>{{ $t("lang.set_prime") }}</span>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs6 sm1 pl-0 pr-2>
                                    <v-layout v-if="hasPerm('parts.update')" row my-auto ml-auto :class="$bp.xsOnly ? 'mr-0' : 'mr-2'">
                                        <v-flex pa-0 style="width: 36px">
                                            <bc-tooltip>
                                                <template slot="activator">
                                                    <v-btn v-if="hover || $bp.smallScreen" icon class="ma-0" @mouseup.left="addPartProcedure(station)">
                                                        <v-icon>add</v-icon>
                                                    </v-btn>
                                                </template>
                                                {{ $t("lang.add_station_procedure") }}
                                            </bc-tooltip>
                                        </v-flex>
                                        <v-flex pa-0 pl-1 style="width: 36px" v-if="hasPerm('parts.delete')">
                                            <bc-tooltip>
                                                <template slot="activator">
                                                    <v-btn
                                                        v-if="
                                                            ((station.prime == '0' && prime_stations[group_index] != station.part_station_id) ||
                                                                (station_group.length == 1 && station.slug != 'furnace')) &&
                                                            (hover || $bp.smallScreen)
                                                        "
                                                        icon
                                                        class="ma-0"
                                                        @mouseup.left="$refs.delete_station.openDialog(), (current_station = station)"
                                                    >
                                                        <v-icon color="red">delete</v-icon>
                                                    </v-btn>
                                                </template>
                                                {{ $t("lang.delete") }}
                                            </bc-tooltip>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-title>
                    </v-hover>
                    <v-divider class="my-0" v-if="station.parts_procedures"></v-divider>
                    <v-card-actions class="pb-0" :style="station.parts_procedures ? '' : 'background-color: rgba(255, 0, 0, .3) !important;'">
                        <v-container fluid pa-0 v-if="station.parts_procedures">
                            <v-treeview ref="tree" :items="station.parts_procedures_tree" open-all disable-per-node>
                                <template slot="prepend" slot-scope="{ item }">
                                    <v-icon v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"></v-icon>
                                </template>
                                <template slot="label" slot-scope="{ item }">
                                    <v-hover>
                                        <v-layout row slot-scope="{ hover }">
                                            <v-flex
                                                @mouseup.left="item.procedure ? openPartProcedure(item, station) : openPartQuestion(item, station)"
                                                xs10
                                                sm11
                                                pa-0
                                                my-auto
                                                clickable
                                                d-inline-flex
                                                :style="$bp.xsOnly ? 'max-width:200px' : ''"
                                            >
                                                <div
                                                    v-if="!item.procedure && item.element_rules.includes('required')"
                                                    :class="{ 'mt-2': $bp.xsOnly }"
                                                    class="red--text"
                                                    style="max-width: 5px; left: -13px; position: relative"
                                                >
                                                    *
                                                </div>
                                                <div
                                                    v-if="$bp.xsOnly"
                                                    class="mt-2"
                                                    :style="!item.procedure && item.element_rules.includes('required') ? 'left:-5px;position:relative;' : ''"
                                                >
                                                    {{ item.name | shrink_text(20) }}
                                                </div>
                                                <div
                                                    v-else
                                                    :style="!item.procedure && item.element_rules.includes('required') ? 'left:-5px;position:relative;' : ''"
                                                >
                                                    {{ item.name }}
                                                </div>
                                            </v-flex>
                                            <v-flex xs2 sm1 pa-0 :class="$bp.xsOnly ? 'ml-auto mr-3' : 'mr-4'">
                                                <v-layout v-if="hasPerm('parts.update')" row my-auto ml-auto>
                                                    <v-flex pa-0 style="width: 36px">
                                                        <bc-tooltip>
                                                            <template slot="activator">
                                                                <v-btn
                                                                    v-if="item.procedure && (hover || $bp.smallScreen)"
                                                                    icon
                                                                    class="ma-0"
                                                                    @click.stop="addPartQuestion(item)"
                                                                >
                                                                    <v-icon style="padding-right: initial !important">add</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            {{ $t("lang.add_procedure_question") }}
                                                        </bc-tooltip>
                                                    </v-flex>
                                                    <v-flex pl-0 py-0 pr-2 style="width: 36px" v-if="hasPerm('parts.delete')">
                                                        <bc-tooltip>
                                                            <template slot="activator">
                                                                <v-btn
                                                                    v-if="hover || $bp.smallScreen"
                                                                    icon
                                                                    class="ma-auto"
                                                                    @click.stop="
                                                                        item.procedure
                                                                            ? ($refs.delete_procedure.openDialog(), (current_procedure = item))
                                                                            : ($refs.delete_question.openDialog(), (current_question = item))
                                                                    "
                                                                >
                                                                    <v-icon color="red" style="padding-right: initial !important">delete</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            {{ item.procedure ? $t("lang.delete_station_procedure") : $t("lang.delete_procedure_question") }}
                                                        </bc-tooltip>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-hover>
                                </template>
                            </v-treeview>
                        </v-container>
                        <v-container fluid pa-0 v-else>
                            <v-layout row>
                                <v-flex xs12 mx-2 mb-2 mt-1 class="fw-bold fs-18">{{ $t("lang.station_must_have_procedure") }}</v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-actions>
                    <v-divider class="mb-0" v-if="station.parts_procedures"></v-divider>
                </div>
            </v-radio-group>
        </v-card>
        <v-card color="grey lighten-4" class="mb-3">
            <v-card-title class="pl-2 py-3 grey lighten-1">
                <div>
                    <div class="headline">QC Inspection</div>
                </div>
            </v-card-title>
        </v-card>
        <v-card color="grey lighten-4" class="mb-3">
            <v-card-title class="pl-2 py-3 grey lighten-1">
                <div>
                    <div class="headline">Repacking</div>
                </div>
            </v-card-title>
        </v-card>
        <v-card color="grey lighten-4" class="mb-3">
            <v-card-title class="pl-2 py-3 grey lighten-1">
                <div>
                    <div class="headline">Shipping</div>
                </div>
            </v-card-title>
        </v-card>
        <bc-dialog :value="part_station_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ current_station.part_station_id ? $t("lang.edit_part_station") : $t("lang.add_part_station") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="part_station_dialog"
                        :dialog-status="part_station_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part_station">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 v-if="current_station.part_station_id" class="primary-chip-container">
                                    <v-chip v-if="current_station.prime == '1'" color="primary" class="primary-chip" disabled>
                                        {{ $t("lang.primary_caps") }}
                                    </v-chip>
                                    <v-switch v-else v-model="part_station.prime" :label="$t('lang.primary')" true-value="1" false-value="0"></v-switch>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        :focus="part_station_dialog && !current_station.part_station_id"
                                        v-model="part_station.station_id"
                                        :label="`${$t('lang.station_id')} *`"
                                        :items="production_stations"
                                        item-value="station_id"
                                        item-text="station"
                                        :rules="ifValid('part_station.station_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="part_station.machine_id"
                                        :label="$t('lang.machine_id')"
                                        :items="machines"
                                        item-value="machine_id"
                                        item-text="machine_name"
                                        :rules="ifValid('part_station.machine_id')"
                                        @change="
                                            !$event
                                                ? $nextTick(() => {
                                                      part_station.machine_id = null;
                                                  })
                                                : null
                                        "
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="part_station.pattern_number"
                                        :label="$t('lang.pattern_number')"
                                        :counter="showCounter(part_station.pattern_number, 'part_station.pattern_number')"
                                        :rules="ifValid('part_station.pattern_number')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-model="part_station.minutes_to_complete"
                                        :label="$t('lang.minutes_to_complete')"
                                        :counter="showCounter(part_station.minutes_to_complete, 'part_station.minutes_to_complete')"
                                        :rules="ifValid('part_station.minutes_to_complete')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="current_station.part_station_id && current_station.prime == '0' && hasPerm('parts.delete')"
                        color="error"
                        @mouseup.left="$refs.delete_station.openDialog()"
                        >{{ $t("lang.delete") }}</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closePartStationDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="modifyPartStation(current_station.part_station_id ? 'patch' : 'post', current_station.part_station_id)"
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="procedure_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ current_procedure.part_procedure_id ? $t("lang.edit_part_procedure") : $t("lang.add_part_procedure") }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="(procedure_dialog = false), $store.commit('validationOff')"
                        :dialog-status="procedure_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part_procedure" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 py-0>
                                    <span>{{ $t("lang.station") }}:</span>
                                    <span class="fs-30">{{ current_station.label }}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-focus="procedure_dialog"
                                        v-model="part_procedure.procedure_name"
                                        :label="`${$t('lang.procedure_name')} *`"
                                        :counter="showCounter(part_procedure.procedure_name, 'part_procedure.procedure_name')"
                                        :rules="ifValid('part_procedure.procedure_name')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="(procedure_dialog = false), $store.commit('validationOff')">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="
                            current_procedure.part_procedure_id
                                ? modifyPartProcedure('patch', current_procedure.part_procedure_id)
                                : modifyPartProcedure('post')
                        "
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="question_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{
                        current_question.part_question_id ? $t("lang.edit_procedure_question") : $t("lang.add_procedure_question")
                    }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="(question_dialog = false), $store.commit('validationOff')"
                        :dialog-status="question_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="part_question">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12 py-0>
                                    <span>{{ $t("lang.procedure") }}:</span>
                                    <span class="fs-30">{{ current_procedure.procedure_name }}</span>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        v-focus="question_dialog"
                                        v-model="part_question.question"
                                        :label="`${$t('lang.question')} *`"
                                        :counter="showCounter(part_question.question, 'part_question.question')"
                                        :rules="ifValid('part_question.question')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <bc-autocomplete
                                        v-model="selected_type"
                                        :label="`${$t('lang.element_type')} *`"
                                        :items="element_type"
                                        item-value="key"
                                        item-text="name"
                                        return-object
                                        :rules="ifValid('part_question.element_type')"
                                        @change="setElementType($event)"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs12 v-if="part_question.element_type == 'v-select'">
                                    <v-text-field
                                        v-model="part_question.element_items"
                                        :label="`${$t('lang.element_items')} *`"
                                        :counter="showCounter(part_question.element_items, 'part_question.element_items')"
                                        :rules="ifValid('part_question.element_items')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 v-if="part_question.element_type == 'v-switch'">
                                    <v-text-field
                                        v-model="part_question.element_items"
                                        :label="`${$t('lang.switch_items')} *`"
                                        :counter="showCounter(part_question.element_items, 'part_question.switch_items')"
                                        :rules="ifValid('part_question.switch_items')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 v-else>
                                    <v-switch v-model="require_question" :label="$t('lang.required')" true-value="required" false-value=""></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="(question_dialog = false), $store.commit('validationOff')">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        color="success"
                        @mouseup.left="
                            current_question.part_question_id ? modifyPartQuestion('patch', current_question.part_question_id) : modifyPartQuestion('post')
                        "
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_station"
            :heading="`${$t('lang.deleting')} '${current_station.label}'`"
            :message="$t('lang.confirm_delete_message_station')"
            @onConfirm="modifyPartStation('delete', current_station.part_station_id)"
        ></delete-confirmation-dialog>
        <delete-confirmation-dialog
            ref="delete_procedure"
            :heading="`${$t('lang.deleting')} '${current_procedure.name}'`"
            :message="$t('lang.confirm_delete_message_procedure')"
            @onConfirm="modifyPartProcedure('delete', current_procedure.part_procedure_id)"
        ></delete-confirmation-dialog>
        <delete-confirmation-dialog
            ref="delete_question"
            :heading="`${$t('lang.deleting')} '${current_question.name}'`"
            :message="$t('lang.confirm_delete_message_question')"
            @onConfirm="modifyPartQuestion('delete', current_question.part_question_id)"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    props: ["part"],
    data() {
        return {
            current_group_index: null,
            require_question: "",
            grouped_stations: {},
            question_dialog: false,
            procedure_dialog: false,
            setting_form_loader: false,
            station_loader_key: 0,
            test_value: [
                { key: 0, value: "test1" },
                { key: 1, value: "test2" },
            ],
            element_type: [
                { key: 0, value: "v-select", name: this.$t("lang.select"), rules: "trim" },
                { key: 1, value: "v-switch", name: this.$t("lang.switch"), rules: "trim" },
                { key: 2, value: "v-text-field", name: this.$t("lang.text"), rules: "trim|max_length[255]" },
                { key: 3, value: "v-text-field", name: this.$t("lang.number"), rules: "trim|numeric|max_length[10]" },
                { key: 4, value: "v-text-field", name: `${this.$t("lang.decimal")} - 0.0`, rules: "trim|numeric[1]|max_length[12]" },
                { key: 5, value: "v-text-field", name: `${this.$t("lang.decimal")} - 0.00`, rules: "trim|numeric[2]|max_length[12]" },
                { key: 6, value: "v-text-field", name: `${this.$t("lang.decimal")} - 0.000`, rules: "trim|numeric[3]|max_length[12]" },
            ],
            current_type: {},
            selected_type: null,
            prime_stations: [],
            update_loader: [],
            initial_stations: [],
            show_all: false,
            part_station_dialog: false,
            part_station: {
                prime: "0",
                station_id: "",
                machine_id: null,
                pattern_number: null,
                minutes_to_complete: null,
            },
            part_procedure: {
                part_station_id: "",
                procedure_name: "",
            },
            part_question: {
                part_procedure_id: "",
                question: "",
                element_type: "",
                element_rules: "",
                element_items: "",
            },
            edit_part: {
                setting_instructions: "",
                setting_minutes_to_complete: "",
            },
            current_station: {},
            current_procedure: {},
            current_question: {},
        };
    },
    watch: {
        require_question(value, old_value) {
            if (value) {
                this.part_question.element_rules += `|${value}`;
            } else {
                if (this.part_question.element_rules)
                    this.part_question.element_rules = this.part_question.element_rules.substring(
                        0,
                        this.part_question.element_rules.length - 1 - old_value.length
                    );
            }
        },
    },
    activated() {
        this.setGroups();
        this.setPrimes();
        this.initial_stations = [...this.prime_stations];
        this.update_loader = Object.entries(this.grouped_stations).length ? Array(Object.entries(this.grouped_stations).length).fill(false) : [];
        this.assignObj(this.edit_part, this.part);
    },
    computed: {
        ...mapState({
            parts_stations: (state) => state.parts.parts_stations,
            rules_part: (state) => state.validation.rules_part,
            rules_part_question: (state) => state.validation.rules_part_question,
            rules_part_procedure: (state) => state.validation.rules_part_procedure,
            rules_part_station: (state) => state.validation.rules_part_station,
            production_stations: (state) => state.production.production_stations,
            machines: (state) => state.machines.machines,
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    methods: {
        setElementType(type) {
            this.part_question.element_type = type.value;
            this.part_question.element_rules = type.rules;
            // this.$nextTick(() => {
            // this.selected_type = type.key;
            // })
        },
        getProductionStations() {
            this.$store.dispatch("fetchProduction", {
                url: "production_stations",
                method: "get",
                stateProperty: "production_stations",
                commit: true,
            });
        },
        getMachines() {
            this.$store.dispatch("fetchMachines", {
                url: `machines?line_id=${this.part.line_id}`,
                method: "get",
                stateProperty: "machines",
                commit: true,
            });
        },
        closePartStationDialog() {
            this.part_station_dialog = false;
            this.$store.commit("validationOff");
        },
        modifyPart() {
            this.$store.commit("validationOn");
            this.$nextTick(() => {
                if (this.validateForm("part")) {
                    this.setting_form_loader = true;
                    this.$store
                        .dispatch("fetchPart", {
                            url: `parts/${this.$route.params.id}`,
                            method: "patch",
                            stateProperty: "part|parts_spec|parts_files",
                            dataProperty: "parts|parts.parts_spec|parts.files",
                            commit: true,
                            body: this.edit_part,
                        })
                        .then((data) => {
                            if (data && data.code == "200") {
                                this.$store.commit("validationOff");
                            }
                            this.setting_form_loader = false;
                        });
                }
            });
        },
        modifyPartQuestion(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("part_question")) {
                        this.$store.commit("toggleModalLoader", true);
                        if (this.part_question.element_type != "v-select" && this.part_question.element_type != "v-switch")
                            delete this.part_question.element_items;
                        let station_index = this.parts_stations.findIndex(
                            (obj) =>
                                obj.part_station_id == (method != "delete" ? this.current_procedure.part_station_id : this.current_question.part_station_id)
                        );
                        let procedure_index = this.parts_stations[station_index]["parts_procedures"].findIndex(
                            (obj) =>
                                obj.part_procedure_id ==
                                (method != "delete" ? this.current_procedure.part_procedure_id : this.current_question.part_procedure_id)
                        );
                        this.$store
                            .dispatch("fetchPart", {
                                pk: "part_question_id",
                                id: id,
                                url: `parts/${this.$route.params.id}/questions/${id ? id : ""}`,
                                method: method,
                                // property_path_array: ['parts_stations', station_index, 'parts_procedures', procedure_index, 'parts_questions'],
                                stateProperty: `parts_stations[${station_index}].parts_procedures[${procedure_index}].parts_questions`,
                                dataProperty: "parts_questions",
                                mutate: true,
                                body: method != "delete" ? this.part_question : null,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.question_dialog = false;
                                    this.$store.commit("validationOff");
                                    this.setGroups();
                                    if (this.$refs.delete_question) this.$refs.delete_question.close();
                                    this.part_question.element_items = "";
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        modifyPartProcedure(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("part_procedure")) {
                        this.$store.commit("toggleModalLoader", true);
                        let station_index = this.parts_stations.findIndex(
                            (obj) => obj.part_station_id == (method == "delete" ? this.current_procedure.part_station_id : this.part_procedure.part_station_id)
                        );
                        this.$store
                            .dispatch("fetchPart", {
                                pk: "part_procedure_id",
                                id: id,
                                url: `parts/${this.$route.params.id}/procedures/${id ? id : ""}`,
                                method: method,
                                stateProperty: `parts_stations[${station_index}].parts_procedures`,
                                dataProperty: "parts_procedures",
                                mutate: true,
                                body: method != "delete" ? this.part_procedure : null,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.procedure_dialog = false;
                                    this.$store.commit("validationOff");
                                    this.setGroups();
                                    if (this.$refs.delete_procedure) this.$refs.delete_procedure.close();
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        openPartQuestion(item, station) {
            this.current_question = item;
            this.current_procedure = item.parent;
            this.assignObj(this.part_question, item);
            this.current_station = station;
            this.selected_type = this.element_type[this.element_type.findIndex((obj) => obj.rules == item.element_rules.replace("|required", ""))];
            this.require_question = item.element_rules.includes("required") ? "required" : "";
            this.question_dialog = true;
        },
        addPartQuestion(procedure) {
            this.require_question = "";
            this.assignObj(this.part_question, null, this.rules_part_question);
            this.part_question.part_procedure_id = procedure.part_procedure_id;
            this.selected_type = null;
            this.current_procedure = procedure;
            this.current_question = {};
            this.question_dialog = true;
        },
        openPartProcedure(item, station) {
            this.current_procedure = item;
            this.assignObj(this.part_procedure, item);
            this.current_station = station;
            this.procedure_dialog = true;
        },
        addPartProcedure(station) {
            this.part_procedure.part_station_id = station.part_station_id;
            this.part_procedure.procedure_name = "";
            this.current_station = station;
            this.procedure_dialog = true;
            this.current_procedure = {};
        },
        setGroups() {
            // console.log('setGroups', this.parts_stations)
            this.grouped_stations = {};
            if (this.parts_stations) {
                let stations_tree = [...this.parts_stations];
                stations_tree.forEach((v, i) => {
                    if (v.parts_procedures) {
                        stations_tree[i].parts_procedures_tree = [];
                        v.parts_procedures.forEach((procedure, ii) => {
                            let procedure_tree = {
                                id: procedure.part_procedure_id,
                                name: procedure.procedure_name,
                                procedure: 1,
                                part_station_id: procedure.part_station_id,
                                part_procedure_id: procedure.part_procedure_id,
                                procedure_name: procedure.procedure_name,
                            };
                            if (procedure.parts_questions) {
                                let questions_tree = [];
                                procedure.parts_questions.forEach((question) => {
                                    questions_tree.push({
                                        id: question.part_question_id,
                                        name: question.question,
                                        question: question.question,
                                        part_question_id: question.part_question_id,
                                        part_procedure_id: question.part_procedure_id,
                                        part_station_id: procedure.part_station_id,
                                        element_rules: question.element_rules,
                                        element_type: question.element_type,
                                        element_items: question.parts_questions_items ? question.parts_questions_items.map((q) => q.item).join("|") : null,
                                        parent: procedure,
                                    });
                                });
                                procedure_tree["children"] = questions_tree;
                            }
                            stations_tree[i].parts_procedures_tree.push(procedure_tree);
                        });
                    }
                });

                this.grouped_stations = _.groupBy(stations_tree, "sort_order");
                this.$nextTick(() => {
                    if (this.$refs.tree) {
                        this.$refs.tree.forEach((branch) => {
                            branch.updateAll(true);
                        });
                    }
                });
            }
        },
        setPrimes() {
            this.prime_stations = [];
            for (const [key, value] of Object.entries(this.grouped_stations)) {
                // console.log(value.length)
                if (this.grouped_stations[key].length > 0) {
                    let skip = false;
                    for (let i = 0; i < value.length && !skip; i++) {
                        let station = value[i];
                        if (station.prime == "1") {
                            this.prime_stations.push(station.part_station_id);
                            skip = true;
                        } else {
                            i == this.grouped_stations[key].length - 1 ? this.prime_stations.push(null) : null;
                        }
                    }
                } else {
                    this.prime_stations.push(null);
                }
            }
        },
        openPartStation(item = null, index = null) {
            this.current_group_index = index;
            this.current_station = item ? item : {};
            this.assignObj(this.part_station, item, this.rules_part_station);
            this.part_station_dialog = true;
            this.getProductionStations();
            this.getMachines();
        },
        modifyPartStation(method = null, part_station_id = null) {
            if (method) {
                if (method != "delete") {
                    this.$store.commit("validationOn");
                }
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("part_station")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchPart", {
                                pk: "part_station_id",
                                id: part_station_id,
                                url: `parts/${this.$route.params.id}/stations/${part_station_id ? part_station_id : ""}`,
                                method: method,
                                stateProperty: "parts_stations",
                                mutate: true,
                                body: this.part_station,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    if (method != "delete") {
                                        this.$store.commit("validationOff");
                                        this.assignObj(this.part_station, null, this.rules_part_station);
                                        this.updatePrimes(data.parts_stations.part_station_id, this.current_group_index);
                                        this.setPrimes();
                                        this.initial_stations = [...this.prime_stations];
                                    }
                                    this.part_station_dialog = false;
                                    this.$store.commit("toggleModalLoader", false);
                                    if (this.$refs.delete_station) this.$refs.delete_station.close();
                                    this.setGroups();
                                }
                            });
                    }
                });
            }
        },
        modifyPartStationPrime(part_station_id = null, index = null) {
            this.$nextTick(() => {
                if (part_station_id) {
                    let body = null;
                    body = { prime: "1" };
                    this.update_loader[index] = true;
                    this.station_loader_key++;
                    this.$store
                        .dispatch("fetchPart", {
                            pk: "part_station_id",
                            id: part_station_id,
                            url: `parts/${this.$route.params.id}/stations/${part_station_id}/prime`,
                            method: "patch",
                            stateProperty: "parts_stations",
                            mutate: true,
                            body: body,
                        })
                        .then((data) => {
                            if (data && data.code == "200") {
                                this.initial_stations[index] = part_station_id;
                                this.update_loader[index] = false;
                                // console.log(this.grouped_stations[Object.keys(this.grouped_stations)[index]])
                                this.updatePrimes(part_station_id, index);

                                if (this.$refs.delete_station) this.$refs.delete_station.close();
                                this.setGroups();
                            }
                        });
                }
            });
        },
        updatePrimes(part_station_id, index) {
            let current = this.grouped_stations[Object.keys(this.grouped_stations)[index]];
            if (current) {
                current.forEach((station) => {
                    if (station.part_station_id != part_station_id && station.prime == "1") {
                        this.$store.commit("mutatePart", {
                            pk: "part_station_id",
                            method: "patch",
                            property: "parts_stations",
                            with: { prime: "0", part_station_id: station.part_station_id },
                        });
                    }
                });
            }
        },
    },
};
</script>
